var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelAnalysisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2679)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 26,
    height: 26,
    rx: 3.25,
    fill: "#84E1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8C16.4696 8 15.9609 7.78929 15.5858 7.41421C15.2107 7.03914 15 6.53043 15 6C15 5.46957 15.2107 4.96086 15.5858 4.58579C15.9609 4.21071 16.4696 4 17 4C17.5304 4 18.0391 4.21071 18.4142 4.58579C18.7893 4.96086 19 5.46957 19 6C19 6.53043 18.7893 7.03914 18.4142 7.41421C18.0391 7.78929 17.5304 8 17 8ZM17 8V12M17 12C17.7956 12 18.5587 12.3161 19.1213 12.8787C19.6839 13.4413 20 14.2044 20 15C20 15.7956 19.6839 16.5587 19.1213 17.1213C18.5587 17.6839 17.7956 18 17 18C16.2044 18 15.4413 17.6839 14.8787 17.1213C14.3161 16.5587 14 15.7956 14 15C14 14.2044 14.3161 13.4413 14.8787 12.8787C15.4413 12.3161 16.2044 12 17 12ZM11.7 18.8L14.5 16.8M22.3 18.8L19.5 16.8M8 20C8 20.5304 8.21071 21.0391 8.58579 21.4142C8.96086 21.7893 9.46957 22 10 22C10.5304 22 11.0391 21.7893 11.4142 21.4142C11.7893 21.0391 12 20.5304 12 20C12 19.4696 11.7893 18.9609 11.4142 18.5858C11.0391 18.2107 10.5304 18 10 18C9.46957 18 8.96086 18.2107 8.58579 18.5858C8.21071 18.9609 8 19.4696 8 20ZM22 20C22 20.5304 22.2107 21.0391 22.5858 21.4142C22.9609 21.7893 23.4696 22 24 22C24.5304 22 25.0391 21.7893 25.4142 21.4142C25.7893 21.0391 26 20.5304 26 20C26 19.4696 25.7893 18.9609 25.4142 18.5858C25.0391 18.2107 24.5304 18 24 18C23.4696 18 22.9609 18.2107 22.5858 18.5858C22.2107 18.9609 22 19.4696 22 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2679",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2679",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelAnalysisIcon);
export default __webpack_public_path__ + "static/media/channelAnalysisIcon.15c6a0b932914bc99c059888e53c2c6d.svg";
export { ForwardRef as ReactComponent };